import React from 'react';
import './LoadingScreen.css';

const LoadingScreen = ({ loadingPercentage }) => {
  return (
    <div id="loading-screen" className="loading-screen">
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {/* <div className="percentage">{loadingPercentage}%</div> */}
        <div>
          <p style={{ fontFamily: 'monospace' }}>Ładuję treści - to może chwilę potrwać. / Loading assets - this may take a second.</p>
        </div>
      </div>
      <div className="loading-bar">
        <div className="loading-bar-inner" style={{ width: `${loadingPercentage}%` }}></div>
      </div>
    </div>
  );
};

export default LoadingScreen;
